import React, { type SVGAttributes } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconLineReader: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 20 20" {...props}>
      <g fill="currentColor">
        <rect x="13" y="11" width="14" height="2"></rect>
        <rect
          fill="none"
          stroke="currentColor"
          x="10.5"
          y="15.5"
          width="19"
          height="4"
          rx="2"
        ></rect>
        <rect x="13" y="22" width="14" height="2"></rect>
        <rect x="13" y="26" width="14" height="2"></rect>
      </g>
    </svg>
  );
};

export default IconLineReader;
